import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../common/services/api/api.service';
import { GETINCIDENTSDATA} from '../common/constants/labels';

@Injectable({
  providedIn: 'root'
})
export class QualityMatrixDataService {
  getIncidentsDataURL = environment.APISETTINGS + GETINCIDENTSDATA;

  constructor(private service: ApiService) { }

  public getIncidentsData(filterParameter): Observable<any> {
    return this.service.post(this.getIncidentsDataURL, filterParameter);
  }
}
